/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */

import React, { useEffect, useRef, useState } from 'react'
import OutlineButton from '../MUICustomButton/OutlineButton'
//@ts-ignore
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Autocomplete, Box, FormControl, Grid, IconButton, InputAdornment, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailSend02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ChartLineData02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { Chart01Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailOpen02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailRemove02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailBlock02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { Cursor02Icon, Download04Icon, Upload04Icon, CursorRectangleSelection02Icon } from '@hugeicons-pro/core-stroke-rounded';

//@ts-ignore
import { ArrowDown01Icon, Cancel01Icon } from '@hugeicons-pro/core-stroke-standard';
import moment from 'moment';
import LineChartComponent from './LineChartComponent';
import BarGraphComponent from './BarGraphComponent';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
//@ts-ignore
import HeatMap from "react-heatmap-grid";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getCampaignReportCardCounts, getCampaignReportData, getCampaignReportDeviceCount, getCampaignReportDomainCount, getResendStatus, getCampaignReportCategoryCount, getCampaignReportHeatmapCount } from 'src/services/campaignService';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
import { styled } from '@mui/material/styles';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import CsvService from 'src/services/dataExport.service';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
//@ts-ignore
import { UserIcon } from '@hugeicons-pro/core-stroke-sharp';
import { toCanvas, toPng } from 'html-to-image';
import { jsPDF } from 'jspdf';
import { getTriggerReportData } from 'src/services/triggerService';
import { getBulkEmailCampaignById } from 'src/services/bulkEmailServices';
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
    [`& .${tooltipClasses.arrow}`]: {
        display: 'none',
    },
}));

const xLabels = new Array(24).fill(0).map((_, i) => `${i}`);

// Display only even labels
const xLabelsVisibility = new Array(24)
    .fill(0)
    .map((_, i) => (i % 2 === 0 ? true : true));

const inputLabels: any = [
    { key: "emailSent", label: "Sent", color: "#3FCEE1" },
    { key: "opens", label: "Opens", color: "#5FD242" },
    { key: "clicks", label: "Clicks", color: "#4B8DF5" },
    { key: "unsubscribes", label: "Unsubscribes", color: "#3A3A3A" },
    { key: "complaints", label: "Complaints", color: "#F95050" }
];
const exportOptions = [
    { label: 'Export as PDF', value: 'pdf' },
    { label: 'Export as CSV', value: 'csv' },
];

function ViewCampaignReports(): JSX.Element {
    const reportContentRef = useRef<HTMLDivElement | null>(null);
    const location = useLocation(); // Get the location object
    const { state } = location || {}; // Extract state from location
    const { start: stateStart, end: stateEnd, campaignName: stateCampaignName, brandName, groupName, type: stateType, resendDateTimeLst, triggerName: stateTriggerName } = state || {}; // Destructure startDate and endDate
    const [campaignName, setCampaignName] = useState<string>(stateCampaignName || '');
    const [triggerName, setTriggerName] = useState<string>(stateTriggerName || '');
    const [start, setStart] = useState<string>(stateStart || '');
    const [end, setEnd] = useState<string>(stateEnd || '');
    const [fromDate, setFromDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [dashboardDateRange, setDashboardDateRange] = useState<any>(null)
    const [graphData, setGraphData] = useState<any>([]);
    const [cardData, setCardData] = useState<any>([])
    const [isDateRangeOpen, setIsDateRangeOpen] = useState<boolean>(false)
    const [alignment, setAlignment] = useState<string>('line');
    const [heatMapAlignment, setHeatmapAlignment] = useState<string>('1');
    const [width, setWidth] = useState<number>(0);
    const [isCardDataLoading, setIsCardDataLoading] = useState<boolean>(false)
    const [isDomainDataLoading, setIsDomainDataLoading] = useState<boolean>(false)
    const [isHeatmapDataLoading, setIsHeatmapDataLoading] = useState<boolean>(false)
    const [domainCount, setDomainCount] = useState<any>([]);
    const [categoryBreakdownCount, setCategoryBreakdownCount] = useState<any>([]);
    const [heatmapData, setHeatmapData] = useState<any>([]);
    const [deviceCount, setDeviceCount] = useState<any>([]);
    const [emailClientCount, setEmailClientCount] = useState<any>([]);
    const [clickByURLCount, setClickByURLCount] = useState<any>([]);
    const [isEmailDataLoading, setIsEmailDataLoading] = useState<boolean>(false)
    const [yLabels, setYLabels] = useState<any>([]);
    const [selectedStatus, setSelectedStatus] = useState<any>(-1);
    const [statusArray, setStatusArray] = useState<any>([]);
    const [interval, setInterval] = useState<number>(0);
    const [exportSelection, setExportSelection] = useState<any>(null);
    const [exportLoading, setExportLoading] = useState<boolean>(false);
    const dateRangeRef: any = useRef(null);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const { user } = useSelector((state: RootState) => state.auth);
    const param = useParams();
    const [includeTestData, setIncludeTestData] = useState<boolean>(false);
    const { id } = param;
    const pathSegment = location.pathname.split('/').filter(Boolean)[0];
    const type = stateType || (pathSegment === 'bulk-email' ? 'bulkemail' : pathSegment === 'trigger' ? 'listtrigger' : 'campaign');

    useEffect(() => {
        if (location.pathname.includes('bulk-email') && id && !campaignName) {
            getBulkEmailCampaignById(id).then((res: any) => {
                if (res.status === 200 && res.data.result === 1) {
                    const campaign = res.data.data;
                    setCampaignName(campaign.bulkCampaignName);
                    setStart(campaign.bulkCampaignStartDate);
                }
            }).catch((error: any) => console.log("Error fetching bulk campaign details: ", error));
        }
    }, [id, location.pathname, campaignName]);

    const navigate = useNavigate()

    useEffect(() => {
        const campaignId = id;
        getResendStatus(campaignId, undefined, type).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    setStatusArray(res.data.data);
                    if (res.data.data.length > 0) {
                        setSelectedStatus(res.data.data[0]);
                    }
                }

            }
        }).catch(
            (error: any) => console.log("Error: ", error)
        )
        const currentDates = getLast7Days();


        const resize = (): void => {
            if (containerRef.current) {
                setWidth(containerRef.current.offsetWidth);
            }
        };

        resize(); // Set on mount

        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: any): void => {
            if (dateRangeRef.current && !dateRangeRef.current.contains(event.target)) {
                setIsDateRangeOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        getCardCountData()
        getDomainCountData()
        getHeatmapCountData(heatMapAlignment)
        getEmailCountData()
        getCategoryBreakdownData()
    }, [user, fromDate, endDate, id, selectedStatus, includeTestData])

    const getCardCountData = (): void => {
        setIsCardDataLoading(true)
        const ClientId = user?.clientId ?? 0;
        const startDate = fromDate != null ? moment(fromDate).format("YYYY-MM-DD") : '';
        const endDateFormatted = endDate != null ? moment(endDate).format("YYYY-MM-DD") : '';
        const diffInDays = moment.duration(moment(endDateFormatted).diff(moment(startDate))).asDays();
        console.log(`Interval is ${diffInDays} days`);
        setInterval(diffInDays);

        const status = selectedStatus?.id ?? -1
        const includeTestDatavalue = includeTestData ? 1 : 0;
        getCampaignReportCardCounts(id, ClientId, startDate, endDateFormatted, status, type, includeTestDatavalue).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    const dataset: any = [];
                    if (res.data.data.chartCounts.length > 0) {
                        res.data.data.chartCounts.map((data: any) => {
                            dataset.push({
                                date: moment(new Date(data.day)).format("MMM DD"),
                                emailSent: data.sends,
                                opens: data.opens,
                                clicks: data.clicks,
                                unsubscribes: data.unSubscribes,
                                complaints: data.complaints
                            })
                        })
                    } else {
                        dataset.push({
                            date: fromDate != null ? moment(new Date(fromDate)).format("MMM DD") : '',
                            emailSent: 0,
                            opens: 0,
                            clicks: 0,
                            unsubscribes: 0,
                            complaints: 0
                        })
                    }
                    setGraphData(dataset)
                    setCardData(res.data.data.cardCounts)
                }

            }
        }).catch(
            (error: any) => console.log("Error: ", error)
        )
            .finally(
                () => setIsCardDataLoading(false)
            )
    }

    const getDomainCountData = (): void => {
        setIsDomainDataLoading(true)
        const ClientId = user?.clientId ?? 0;
        const startDate = fromDate != null ? moment(fromDate).format("YYYY-MM-DD") : '';
        const endDateFormatted = endDate != null ? moment(endDate).format("YYYY-MM-DD") : '';
        const status = selectedStatus?.id ?? -1
        const includeTestDatavalue = includeTestData ? 1 : 0;
        getCampaignReportDomainCount(id, ClientId, startDate, endDateFormatted, status, type, includeTestDatavalue).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    setDomainCount(res.data.data)
                }

            }
        }).catch(
            (error: any) => console.log("Error: ", error)
        )
            .finally(
                () => setIsDomainDataLoading(false)
            )
    }

    const getHeatmapCountData = (heatmapEventFilter?: any): void => {
        setIsHeatmapDataLoading(true)
        const ClientId = user?.clientId ?? 0;
        const startDate = fromDate != null ? moment(fromDate).format("YYYY-MM-DD") : '';
        const endDateFormatted = endDate != null ? moment(endDate).format("YYYY-MM-DD") : '';
        const status = selectedStatus?.id ?? -1
        const includeTestDatavalue = includeTestData ? 1 : 0;
        const heatmapRequest = type === 'listtrigger'
            ? getCampaignReportDomainCount(id, ClientId, startDate, endDateFormatted, status, type,includeTestDatavalue, heatmapEventFilter ? heatmapEventFilter : 1, )
            : getCampaignReportHeatmapCount(id, ClientId, startDate, endDateFormatted, status, type, heatmapEventFilter ? heatmapEventFilter : 1, includeTestDatavalue);
        heatmapRequest.then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    const hData = type === 'listtrigger' ? (res.data.data?.heatmapData ?? []) : res.data.data;

                    if (hData.length > 0) {
                        // Extract Y-axis labels (dates)
                        const yLabels = hData.map((data: any) => data.dayofweek.substring(0, 3));

                        // Prepare heatmap matrix
                        const heatmapMatrix = hData.map((data: any) => {
                            const hourCounts = data.hourCounts;
                            return Object.keys(hourCounts).map((hour) => hourCounts[hour]);
                        });

                        setYLabels(yLabels); // Set Y-axis labels
                        setHeatmapData(heatmapMatrix); // Set heatmap matrix
                    }
                }

            }
        }).catch(
            (error: any) => console.log("Error: ", error)
        )
            .finally(
                () => setIsHeatmapDataLoading(false)
            )
    }

    const getEmailCountData = (): void => {
        setIsEmailDataLoading(true)
        const ClientId = user?.clientId ?? 0;
        const startDate = fromDate != null ? moment(fromDate).format("YYYY-MM-DD") : '';
        const endDateFormatted = endDate != null ? moment(endDate).format("YYYY-MM-DD") : '';
        const status = selectedStatus?.id ?? -1
        const includeTestDatavalue = includeTestData ? 1 : 0;
        getCampaignReportDeviceCount(id, ClientId, startDate, endDateFormatted, status, type, includeTestDatavalue).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    setDeviceCount(res.data.data.deviceMtrcCounts)
                    setEmailClientCount(res.data.data.clientMtrPercentage)
                    setClickByURLCount(res.data.data.clicksByURL)
                }

            }
        }).catch(
            (error: any) => console.log("Error: ", error)
        )
            .finally(
                () => setIsEmailDataLoading(false)
            )
    }

    const getCategoryBreakdownData = (): void => {
        setIsEmailDataLoading(true)
        const ClientId = user?.clientId ?? 0;
        const startDate = fromDate != null ? moment(fromDate).format("YYYY-MM-DD") : '';
        const endDateFormatted = endDate != null ? moment(endDate).format("YYYY-MM-DD") : '';
        const status = selectedStatus?.id ?? -1
        const includeTestDatavalue = includeTestData ? 1 : 0;
        getCampaignReportCategoryCount(id, ClientId, startDate, endDateFormatted, status, type, includeTestDatavalue).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    console.log(res.data);
                    setCategoryBreakdownCount(res.data.data.categorySummary);
                    // setDeviceCount(res.data.data.deviceMtrcCounts)
                    // setEmailClientCount(res.data.data.clientMtrPercentage)
                    // setClickByURLCount(res.data.data.clicksByURL)
                }

            }
        }).catch(
            (error: any) => console.log("Error: ", error)
        )
            .finally(
                () => setIsEmailDataLoading(false)
            )
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars


    const handleDateChange = (): void => {
        setIsDateRangeOpen(true)
        // const currentDates = getLast7Days();
        setDashboardDateRange({
            startDate: fromDate ?? new Date(),
            endDate: endDate ?? new Date(),
            key: 'selection'
        })

        // setFromDate(currentDates.startDate)
        // setEndDate(currentDates.endDate)
    }
    const getDateRangeDisplayValue = (): string => {
        if (fromDate && endDate) {
            return `${moment(fromDate).format('MM/DD/YYYY')} - ${moment(endDate).format('MM/DD/YYYY')}`;
        }
        return '';
    };
    const handleClearDateRange = (): void => {
        setFromDate(null);
        setEndDate(null);
        setDashboardDateRange(null);
    };

    const getLast7Days = (): any => {
        const now = new Date();
        const endDate = new Date(now); // Today
        const startDate = new Date();
        startDate.setDate(now.getDate() - 6); // Go back 6 days (including today, makes 7 days)

        return {
            startDate,
            endDate
        };
    };

    const handleDateRangeClick = (ranges: any): void => {
        const selectedStart = ranges.selection.startDate;
        const selectedEnd = ranges.selection.endDate;
        setDashboardDateRange({ startDate: selectedStart, endDate: selectedEnd, key: 'selection' });
        if (selectedStart !== selectedEnd) {
            setFromDate(selectedStart);
            setEndDate(selectedEnd);
            setTimeout(() => setIsDateRangeOpen(false), 500);
        }

    }

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ): void => {
        setAlignment(newAlignment);
    };

    // Determine the resend start date based on selectedStatus
    const getResendStartDate = (): string | null => {
        if (!resendDateTimeLst?.length) return null;

        const resendStatus = selectedStatus?.resendStatus?.toLowerCase();
        if (!resendStatus || resendStatus === "all" || resendStatus === "initial send") return null;

        const statusMap: Record<string, number> = {
            first: 1,
            second: 2,
            third: 3,
            fourth: 4,
            fifth: 5,
            sixth: 6,
            seventh: 7,
            eighth: 8,
            ninth: 9,
            tenth: 10,
        };

        const matchedKey = Object.keys(statusMap).find(key => resendStatus.includes(key));
        const resendOrder = matchedKey ? statusMap[matchedKey] : null;

        if (!resendOrder) return null;

        const resendOrderMatch = resendDateTimeLst.find((item: any) => item.resendOrder === resendOrder);

        return resendOrderMatch
            ? moment(resendOrderMatch.resendDateTime).format("MM/DD/YYYY hh:mm A")
            : null;
    };


    const handleHeatmapChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ): void => {
        setHeatmapAlignment(newAlignment);
        getHeatmapCountData(newAlignment);
    };

    const control = {
        value: alignment,
        onChange: handleChange,
        exclusive: true,
    };

    const control1 = {
        value: heatMapAlignment,
        onChange: handleHeatmapChange,
        exclusive: true,
    };

    const today = new Date();
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(today.getDate() - 90);

    const handleBackClick = (): void => {

        type === 'bulkemail' ? navigate(`/bulk-email`) : type === "listtrigger" ? navigate('/trigger') : navigate(`/campaigns`);
    }

    const handleExportReport = (): void => {
        setExportLoading(true);
        setExportSelection(null);
        const start = fromDate != null ? moment(fromDate).format("YYYY-MM-DD") : '';
        const end = endDate != null ? moment(endDate).format("YYYY-MM-DD") : '';
        const statusId = selectedStatus?.id ?? 0
        const reporttype = type === 'bulkemail' ? 'bulkemail' : '';
        const includeTestDatavalue = includeTestData ? 1 : 0;
        if (type === 'listtrigger') {
            getTriggerReportData(id)
                .then((res: any) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            const reportData = res.data.data;

                            const data: any = [];
                            if (reportData.length > 0) {


                                reportData.map((item: any) => {
                                    const newItem = {
                                        "Campaign Id": item.campaignId,
                                        "Event Id": item.eventId,
                                        "Event Type": item.eventType,
                                        "Event Time": moment(item.eventTime).format("MM-DD-YYYY HH:mm:ss"),
                                        "Event Data": item.eventData,
                                        "NPI": item.npi,
                                        "Template Id": item.templateId,
                                        "From Name": item.fromName,
                                        "Client": item.client
                                    }

                                    data.push(newItem)
                                })

                                const csvData = CsvService.jsonToCsv(data);
                                CsvService.downloadCsvFile(csvData, 'ListTriggerReport.csv');
                                setExportLoading(false);
                                setExportSelection(null);
                            } else {
                                setExportLoading(false);
                                NotificationManager.error('No data available for download', '', 5000);
                            }
                        } else {
                            setExportLoading(false);
                            NotificationManager.error('No data available for download', '', 5000);
                        }
                    }
                })
        } else {
            getCampaignReportData(id, start, end, statusId, reporttype, includeTestDatavalue)
                .then((res: any) => {
                    if (res.status === 200) {
                        console.log(res)
                        if (res.data.result === 1) {
                            const reportData = res.data.data;

                            const data: any = [];
                            if (reportData.length > 0) {

                                reportData.map((item: any) => {
                                    const newItem = {
                                        "Campaign Id": type === 'bulkemail' ? item.bulkCampaignId : item.campaignId,
                                        "Event Id": item.eventId,
                                        "Event Type": item.eventType,
                                        "Event Time": moment(item.eventTime).format("MM-DD-YYYY HH:mm:ss"),
                                        "Event Data": item.eventData,
                                        "NPI": item.npi,
                                        "Template Id": item.templateId,
                                        "From Name": item.fromName,
                                        "Brand": item.brand,
                                        "Request Id": item.requestId,
                                    }

                                    data.push(newItem)
                                })

                                const csvData = CsvService.jsonToCsv(data);
                                CsvService.downloadCsvFile(csvData, 'CampaignReport.csv');
                                setExportLoading(false);
                                setExportSelection(null);
                            } else {
                                setExportLoading(false);
                                NotificationManager.error('No data available for download', '', 5000);
                            }
                        } else {
                            setExportLoading(false);
                            NotificationManager.error('No data available for download', '', 5000);
                        }
                    }
                    else {
                        setExportLoading(false);
                        NotificationManager.error('Unknown error has occurred', '', 5000);
                    }
                })
        }

    }

    const domainColumns = [
        {
            name: 'Domain',
            selector: (row: any) => row.domainName,
            width: '30%',
            cell: (row: any) => {
                return (
                    <BootstrapTooltip title={row.domainName}>
                        <div className='text-muted text-14 whitespace-nowrap overflow-hidden text-ellipsis'>{row.domainName}</div>
                    </BootstrapTooltip>
                )
            }
        },
        {
            name: '%',
            selector: (row: any) => row.percentageUsage,
            cell: (row: any) => {
                return (
                    <div className='flex flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.percentageUsage}%</div>
                        {/* <div className="table-error">-2%</div> */}
                    </div>
                )
            },
            width: '17%'
        },
        {
            name: <BootstrapTooltip title='Delivery Rate'><span className='whitespace-nowrap text-ellipsis overflow-hidden'>Delivery Rate</span></BootstrapTooltip>,
            selector: (row: any) => row.deliveryRate,
            cell: (row: any) => {
                return (
                    <div className='flex flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.deliveryRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            },
            width: '17%'
        },
        // {
        //     name: 'Bounce Rate',
        //     selector: (row: any) => row.clicks,
        //     cell: (row: any) => {
        //         return (
        //             <div className='flext flex-col gap-x-[5px] text-right'>
        //                 <div className='text-muted text-14 table-count-data'>{row.clicks}%</div>
        //                 <div className="table-error">-2%</div>
        //             </div>
        //         )
        //     }
        // },

        {
            name: <BootstrapTooltip title='Open Rate'><span className='whitespace-nowrap text-ellipsis overflow-hidden'>Open Rate</span></BootstrapTooltip>,
            selector: (row: any) => row.openRate,
            cell: (row: any) => {
                return (
                    <div className='flex flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.openRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            },
            width: '17%'
        },
        {
            name: <BootstrapTooltip title='Click Rate'><span className='whitespace-nowrap text-ellipsis overflow-hidden'>Click Rate</span></BootstrapTooltip>,
            selector: (row: any) => row.clickRate,
            cell: (row: any) => {
                return (
                    <div className='flex flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.clickRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            },
            width: '17%'

        },
    ]

    const deviceColumns = [
        {
            name: 'Device Type',
            selector: (row: any) => row.emailDeviceType,
            width: '35%'
        },
        // {
        //     name: '%',
        //     selector: (row: any) => row.percentageUsage,
        //     cell: (row: any) => {
        //         return (
        //             <div className='flex flex-col gap-x-[5px] text-right'>
        //                 <div className='text-muted text-14 table-count-data'>{row.percentageUsage}%</div>
        //                 {/* <div className="table-success">+2%</div> */}
        //             </div>
        //         )
        //     }
        // },
        {
            name: 'Open Rate',
            selector: (row: any) => row.openRate,
            cell: (row: any) => {
                return (
                    <div className='flex flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.openRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            }
        },
        {
            name: 'Click Rate',
            selector: (row: any) => row.clickRate,
            cell: (row: any) => {
                return (
                    <div className='flex flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.clickRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            }
        },
    ]

    const clickColumns = [
        {
            name: 'URL',
            selector: (row: any) => row.url,
            width: '50%',
            cell: (row: any) => {
                return (
                    <BootstrapTooltip title={row.url}>
                        <span className="truncate" style={{ maxWidth: "150px" }}>
                            {row.url}
                        </span>
                    </BootstrapTooltip>
                )
            }
        },
        {
            name: 'Unique Clicks',
            selector: (row: any) => row.uniqueClicks,
            cell: (row: any) => {
                return (
                    <div className='flex flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.uniqueClicks}</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            },

            width: '25%'
        },
        // {
        //     name: 'Delivered',
        //     selector: (row: any) => row.delivered,
        // },
        // {
        //     name: 'Open',
        //     selector: (row: any) => row.opens,
        //     // width: '15%'
        // },
        {
            name: 'Total Clicks',
            selector: (row: any) => row.totalClicks,
            cell: (row: any) => {
                return (
                    <div className='flex flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.totalClicks}</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            },
            width: '25%'
        },
    ]

    const emailClientColumns = [
        {
            name: 'Email Clients',
            selector: (row: any) => row.emailClientName,
            width: '70%'
        },
        {
            name: '%',
            selector: (row: any) => row.percentage,
            cell: (row: any) => {
                return (
                    <div className='flex flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.percentage}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            }
        },
    ]

    const categoryBreakdownColumns = [
        {
            name: 'Category',
            selector: (row: any) => row.category,
            width: '30%',
            cell: (row: any) => (
                <BootstrapTooltip title={row.category}>
                    <div className="text-muted text-14 whitespace-nowrap overflow-hidden text-ellipsis">
                        {row.category?.length > 30 ? `${row.category.slice(0, 30)}...` : row.category}
                    </div>
                </BootstrapTooltip>
            ),
        },
        {
            name: '%',
            selector: (row: any) => row.percentageUsage,
            width: '17%',
            cell: (row: any) => (
                <div className="flex flex-col gap-x-[5px] text-right">
                    <div className="text-muted text-14 table-count-data">{row.percentageUsage}%</div>
                </div>
            ),
        },
        {
            name: (
                <BootstrapTooltip title="Delivery Rate">
                    <span className="whitespace-nowrap text-ellipsis overflow-hidden">Delivery Rate</span>
                </BootstrapTooltip>
            ),
            selector: (row: any) => row.deliveryRate,
            width: '17%',
            cell: (row: any) => (
                <div className="flex flex-col gap-x-[5px] text-right">
                    <div className="text-muted text-14 table-count-data">{row.deliveryRate}%</div>
                </div>
            ),
        },
        {
            name: (
                <BootstrapTooltip title="Open Rate">
                    <span className="whitespace-nowrap text-ellipsis overflow-hidden">Open Rate</span>
                </BootstrapTooltip>
            ),
            selector: (row: any) => row.openRate,
            width: '17%',
            cell: (row: any) => (
                <div className="flex flex-col gap-x-[5px] text-right">
                    <div className="text-muted text-14 table-count-data">{row.openRate}%</div>
                </div>
            ),
        },
        {
            name: (
                <BootstrapTooltip title="Click Rate">
                    <span className="whitespace-nowrap text-ellipsis overflow-hidden">Click Rate</span>
                </BootstrapTooltip>
            ),
            selector: (row: any) => row.clickRate,
            width: '17%',
            cell: (row: any) => (
                <div className="flex flex-col gap-x-[5px] text-right">
                    <div className="text-muted text-14 table-count-data">{row.clickRate}%</div>
                </div>
            ),
        },
    ];


    const getBrowserZoomLevel = (): number => {
        const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
        if (isFirefox) {
            return 100;
        }
        const zoomLevel = (window.outerWidth / window.innerWidth) * 100;
        return Math.floor(zoomLevel);
    };

    const handleReportDownload = async (): Promise<void> => {

        console.log("getBrowserZoomLevel()", getBrowserZoomLevel());
        if (getBrowserZoomLevel() === 100) {
            const element = reportContentRef.current;
            setExportLoading(true);

            if (!element) {
                NotificationManager.error('Report content not found', '', 5000);
                setExportLoading(false);
                return;
            }

            try {
                // 1️⃣ Clone the report content
                const clonedElement = element.cloneNode(true) as HTMLElement;

                // 2️⃣ Add heading ONLY to cloned element
                const heading = document.createElement('div');
                heading.innerText = `Campaign Report - ID: ${id}`;
                heading.style.fontSize = '24px';
                heading.style.fontWeight = 'bold';
                heading.style.textAlign = 'left';
                heading.style.marginBottom = '20px';
                heading.style.backgroundColor = '#ffffff';
                clonedElement.insertBefore(heading, clonedElement.firstChild);

                // 3️⃣ Fix ONLY heatmap styling in cloned element for PDF
                const fixHeatmapForPDF = (container: HTMLElement): void => {
                    // Find heatmap containers
                    const heatmapContainers = container.querySelectorAll('.heatmap-container');

                    heatmapContainers.forEach((heatmapContainer: any) => {
                        // Fix main container
                        heatmapContainer.style.setProperty('width', '100%', 'important');
                        heatmapContainer.style.setProperty('max-width', '700px', 'important');
                        heatmapContainer.style.setProperty('overflow', 'visible', 'important');
                        heatmapContainer.style.setProperty('min-width', 'auto', 'important');
                        heatmapContainer.style.setProperty('position', 'relative', 'important');
                        heatmapContainer.style.setProperty('z-index', '10', 'important');
                        heatmapContainer.style.setProperty('margin', '0', 'important');
                        heatmapContainer.style.setProperty('padding', '0', 'important');

                        const parent = heatmapContainer.parentElement;
                        if (parent) {
                            parent.style.setProperty('overflow', 'visible', 'important');
                            parent.style.setProperty('width', '100%', 'important');
                        }

                        // 1. Target individual heatmap cells
                        const cells = heatmapContainer.querySelectorAll('[id="single-heatmap-cell"]');
                        cells.forEach((cell: any) => {
                            cell.style.setProperty('width', '20px', 'important');
                            cell.style.setProperty('height', '20px', 'important');
                            cell.style.setProperty('min-width', '20px', 'important');
                            cell.style.setProperty('max-width', '20px', 'important');
                            cell.style.setProperty('font-size', '9px', 'important');
                            cell.style.setProperty('margin', '1px', 'important');
                            cell.style.setProperty('display', 'flex', 'important');
                            cell.style.setProperty('align-items', 'center', 'important');
                            cell.style.setProperty('justify-content', 'center', 'important');
                            cell.style.setProperty('border-radius', '4px', 'important');
                        });

                        // 2. Target X-axis labels container and individual labels
                        const xLabelsContainer = heatmapContainer.querySelector('#x-labels-list');
                        if (xLabelsContainer) {
                            xLabelsContainer.style.setProperty('display', 'flex', 'important');
                            xLabelsContainer.style.setProperty('width', '100%', 'important');
                            xLabelsContainer.style.setProperty('margin', '0', 'important');
                            
                            const xLabels = xLabelsContainer.querySelectorAll('div');
                            xLabels.forEach((label: any) => {
                                // Skip the y-label spacer if it's inside x-labels-list
                                if (label.id === 'y-label') {
                                    label.style.setProperty('width', '50px', 'important');
                                    label.style.setProperty('min-width', '50px', 'important');
                                } else {
                                    label.style.setProperty('width', '20px', 'important');
                                    label.style.setProperty('min-width', '20px', 'important');
                                    label.style.setProperty('max-width', '20px', 'important');
                                    label.style.setProperty('font-size', '9px', 'important');
                                    label.style.setProperty('margin', '1px', 'important');
                                    label.style.setProperty('text-align', 'center', 'important');
                                }
                            });
                        }

                        // 3. Target Y-axis labels container and individual labels
                        const yLabelsContainer = heatmapContainer.querySelector('#y-label');
                        if (yLabelsContainer) {
                            yLabelsContainer.style.setProperty('width', '50px', 'important');
                            yLabelsContainer.style.setProperty('min-width', '50px', 'important');
                            
                            const yLabels = yLabelsContainer.querySelectorAll('div');
                            yLabels.forEach((label: any) => {
                                label.style.setProperty('width', '50px', 'important');
                                label.style.setProperty('min-width', '50px', 'important');
                                label.style.setProperty('max-width', '50px', 'important');
                                label.style.setProperty('font-size', '9px', 'important');
                                label.style.setProperty('height', '20px', 'important');
                                label.style.setProperty('display', 'flex', 'important');
                                label.style.setProperty('align-items', 'center', 'important');
                                label.style.setProperty('margin-bottom', '2px', 'important');
                            });
                        }

                        // 4. Final check: if the library uses a different structure, target all divs inside
                        const allDivs = heatmapContainer.querySelectorAll('div');
                        allDivs.forEach((div: any) => {
                            if (div.id === 'single-heatmap-cell') {
                                div.style.setProperty('width', '20px', 'important');
                                div.style.setProperty('height', '20px', 'important');
                                div.style.setProperty('min-width', '20px', 'important');
                            }
                        });
                    });
                };

                // 4️⃣ Apply heatmap fixes to cloned element
                fixHeatmapForPDF(clonedElement);

                // 5️⃣ Hide scrollbars in cloned content
                const scrollables = clonedElement.querySelectorAll('*');
                scrollables.forEach((el: any) => {
                    el.style.scrollbarWidth = 'none';
                    el.style.msOverflowStyle = 'none';
                });

                // 6️⃣ Append cloned content off-screen with fixed width
                const container = document.createElement('div');
                container.style.position = 'fixed';
                container.style.top = '-99999px';
                container.style.left = '-99999px';
                container.style.width = '1200px'; // Fixed width for consistent rendering
                container.style.backgroundColor = '#ffffff';
                container.style.padding = '20px';
                container.style.fontFamily = 'system-ui, -apple-system, sans-serif';
                container.appendChild(clonedElement);
                document.body.appendChild(container);

                // const ensureFonts = (element: HTMLElement): void => {
                //     const all = element.querySelectorAll<HTMLElement>('*');
                //     all.forEach(el => {
                //         const computed = window.getComputedStyle(el);
                //         const font = computed.fontFamily;
                //         if (!font || font === 'undefined') {
                //             el.style.fontFamily = 'Arial, sans-serif';
                //         }
                //     });
                //     element.style.fontFamily = 'Arial, sans-serif';
                // };

                // ensureFonts(clonedElement);

                // 7️⃣ Wait for heatmap to fully render with new styles
                await new Promise((resolve) => setTimeout(resolve, 800));

                const dataUrl = await toPng(clonedElement, {
                    cacheBust: true,
                    backgroundColor: '#ffffff',
                    width: 1200, // or containerRef.current.offsetWidth
                    height: clonedElement.scrollHeight,
                    style: {
                        transform: 'scale(1)',
                        transformOrigin: 'top left',
                        width: '1200px',
                    },
                    pixelRatio: 2, // consistent image resolution regardless of zoom
                    skipAutoScale: true, // prevent html-to-image from adapting to current zoom
                    skipFonts: true
                });


                // 9️⃣ Clean up cloned content
                document.body.removeChild(container);

                // 🔟 Generate & Save PDF
                const pdf = new jsPDF({
                    orientation: 'portrait',
                    unit: 'mm',
                    format: 'a3'
                });

                const img = new Image();
                img.src = dataUrl;

                img.onload = () => {
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = pdf.internal.pageSize.getHeight();
                    const margin = 10;

                    const scale = Math.min(
                        (pdfWidth - margin * 2) / img.width,
                        (pdfHeight - margin * 2) / img.height
                    );

                    const imgWidth = img.width * scale;
                    const imgHeight = img.height * scale;
                    const x = (pdfWidth - imgWidth) / 2;
                    const y = margin;

                    pdf.addImage(img, 'PNG', x, y, imgWidth, imgHeight);
                    pdf.save(`campaign-report-${id}.pdf`);
                    NotificationManager.success("PDF generated successfully", '', 5000);
                    setExportLoading(false);
                    setExportSelection(null);
                };

                img.onerror = () => {
                    setExportLoading(false);
                    setExportSelection(null);
                    NotificationManager.error('Failed to generate PDF. Try again.', '', 5000);
                };

            } catch (error) {
                setExportLoading(false);
                setExportSelection(null);
                console.error('PDF export failed:', error);
                NotificationManager.error('Failed to generate PDF. Try again.', '', 5000);
            }
        } else {
            NotificationManager.error('Zoom level must be 100% for better PDF file creation.', '', 5000);
        }
    };

    return (
        <>

            <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-[20px] gap-y-4" >
                <div className="flex flex-wrap items-center gap-4 lg:gap-x-[30px]" >
                    <h1 className="text-2xl text-title font-semibold">{type === "listtrigger" ? "List Trigger Id" : "Campaign ID"}: {id}</h1>

                    <div>
                        {statusArray.length > 0 &&
                            <FormControl fullWidth>
                                <Autocomplete
                                    options={statusArray}
                                    getOptionLabel={(option) => option.resendStatus}
                                    popupIcon={
                                        <HugeiconsIcon
                                            icon={ArrowDown01Icon}
                                            size={18}
                                            color="#3A3A3A"
                                            strokeWidth={0.2}

                                        />
                                    }
                                    onChange={(event, newValue) => {
                                        setSelectedStatus(newValue);
                                        console.log("Selected status: ", newValue)
                                    }}
                                    value={selectedStatus}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Status"
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '40px',
                                                    height: '40px',
                                                    width: '200px', // Increased width
                                                },
                                            }}
                                        />
                                    )}
                                    sx={{
                                        '& .MuiAutocomplete-clearIndicator': {
                                            marginRight: '-12px'
                                        },
                                        '& .MuiAutocomplete-input': {
                                            width: '70%'
                                        }
                                    }}

                                />
                            </FormControl>
                        }
                    </div>
                    <div className='mr-[20px] status-autocomplete'>
                        <FormControl>
                            <TextField
                                id="date-range"
                                label="Date Range"
                                variant="outlined"
                                autoComplete='off'
                                ref={dateRangeRef}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                                            {getDateRangeDisplayValue() && (
                                                <IconButton
                                                    onClick={handleClearDateRange}
                                                    size="small"
                                                    sx={{ marginRight: '4px' }}
                                                >
                                                    <HugeiconsIcon
                                                        icon={Cancel01Icon}
                                                        size={16}
                                                        color="#666"
                                                        strokeWidth={0.5}
                                                    />
                                                </IconButton>
                                            )}
                                            <HugeiconsIcon
                                                icon={Calendar03Icon}
                                                size={18}
                                                color="#3A3A3A"
                                                strokeWidth={0.5}
                                                onClick={handleDateChange}
                                            />
                                        </InputAdornment>
                                    )
                                }}
                                onChange={handleDateChange}
                                onFocus={handleDateChange}
                                value={getDateRangeDisplayValue()}
                                placeholder="Select date range"
                                sx={{
                                    width: { xs: '100%', sm: '225px', md: '225px', lg: '225px' },
                                    minWidth: '270px',
                                    '& .MuiOutlinedInput-root': {
                                        height: '56px',
                                        '& .MuiOutlinedInput-input': {
                                            padding: '16px 14px',
                                            height: 'auto',
                                            lineHeight: '1.4375em',
                                        },
                                    },
                                    '& .MuiInputLabel-root': {
                                        padding: '0 4px',
                                        fontSize: '13px',
                                        lineHeight: '1.2',
                                    },
                                }}
                            />
                            {isDateRangeOpen && (
                                <div ref={dateRangeRef} style={{ position: 'absolute', zIndex: '999', top: '100%', marginTop: '4px' }}>
                                    <DateRangePicker
                                        ranges={dashboardDateRange ? [dashboardDateRange] : []}
                                        onChange={handleDateRangeClick}
                                        dateDisplayFormat={'MM/dd/yyyy'}
                                        inputRanges={[]}
                                        color={"#FFF5F6"}
                                        rangeColors={["#D6242C"]}
                                        editableDateInputs={true}
                                        startDatePlaceholder={"MM/DD/YYYY"}
                                        endDatePlaceholder={"MM/DD/YYYY"}
                                    />
                                </div>
                            )}
                        </FormControl>
                    </div>
                    <div>
                        <Autocomplete
                            clearOnEscape
                            options={exportOptions}
                            disabled={exportLoading}
                            popupIcon={
                                <HugeiconsIcon
                                    icon={ArrowDown01Icon}
                                    size={18}
                                    color="#3A3A3A"
                                    strokeWidth={0.2}
                                />
                            }
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            onChange={(event, newValue) => {
                                if (newValue?.value === 'pdf') {
                                    void handleReportDownload();
                                } else if (newValue?.value === 'csv') {
                                    handleExportReport();
                                }
                                setExportSelection(newValue);
                            }}
                            value={exportSelection}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={exportLoading ? "" : "Export"}
                                    variant="outlined"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '40px',
                                            height: '40px',
                                            width: '200px',
                                            position: 'relative',
                                        },
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        readOnly: exportLoading,
                                        sx: {
                                            '& input': {
                                                opacity: exportLoading ? 0 : 1,
                                                pointerEvents: exportLoading ? 'none' : 'auto',
                                            }
                                        },
                                        startAdornment: exportLoading && (
                                            <>
                                                <div style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    backgroundColor: 'white',
                                                    zIndex: 1,
                                                    borderRadius: '40px'
                                                }} />
                                                <div style={{
                                                    position: 'absolute',
                                                    left: '50%',
                                                    top: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    zIndex: 2
                                                }}>
                                                    <span className="loading loading-spinner loading-sm text-primary"></span>
                                                </div>
                                            </>
                                        ),
                                    }}
                                />
                            )}
                            sx={{
                                pointerEvents: exportLoading ? 'none' : 'auto',
                                '& .MuiAutocomplete-clearIndicator': {
                                    visibility: exportLoading ? 'hidden' : 'visible',
                                },
                                '& .MuiAutocomplete-popupIndicator': {
                                    visibility: exportLoading ? 'hidden' : 'visible',
                                },
                                '& .MuiInputLabel-root': {
                                    opacity: exportLoading ? 0 : 1,
                                },
                                '& .MuiAutocomplete-input': {
                                    opacity: exportLoading ? 0 : 1,
                                },
                                '& .MuiChip-root': {
                                    opacity: exportLoading ? 0 : 1,
                                },
                            }}
                        />
                    </div>


                </div>
                <div>
                    <OutlineButton onClick={handleBackClick} type='rounded' color='red' width='200px'>
                        <img src="/assets/images/red-arrow.svg" alt="arrow" width={9} height={8} className="mr-[5px] mt-[1px]" />
                        {type !== "bulkemail" ? type === "listtrigger" ? "List Trigger Overview" : "Trigger Email Overview" : "Bulk Email Overview"}
                    </OutlineButton>
                </div>
            </div>


            <div ref={reportContentRef} >
                <div className="flex gap-x-[30px] items-center mb-[20px]">
                    <div className="text-14 text-muted">
                        <span className='font-semibold'>{type === "listtrigger" ? "List Trigger Name" : "Campaign Name"}:</span> {type === "listtrigger" ? triggerName : campaignName}
                    </div>
                    <div className="text-14 text-muted">
                        <span className="font-semibold">
                            {(() => {
                                const status = selectedStatus?.resendStatus?.toLowerCase();
                                if (!status || status.toLowerCase() === "initial send" || status.toLowerCase() === "all")
                                    return type === "listtrigger" ? "Trigger Start:" : "Campaign Start:";
                                const numberMap: Record<string, string> = {
                                    first: "First",
                                    second: "Second",
                                    third: "Third",
                                    fourth: "Fourth",
                                    fifth: "Fifth",
                                    sixth: "Sixth",
                                    seventh: "Seventh",
                                    eighth: "Eighth",
                                    ninth: "Nineth",
                                    tenth: "Tenth",
                                };

                                const matchedKey = Object.keys(numberMap).find(key => status.includes(key));
                                return matchedKey ? `${numberMap[matchedKey]} resend:` : "Resend:";
                            })()}
                        </span>{" "}
                        {moment(getResendStartDate() ?? start).format("MM/DD/YYYY h:mm A")}
                    </div>
                    {
                        type !== "bulkemail" && (
                            <React.Fragment>
                                <div className="text-14 text-muted">
                                    <span className='font-semibold'>{type === "listtrigger" ? "Trigger End" : "Campaign End"}:</span> {moment(end).format("MM/DD/YYYY h:mm A")}
                                </div>
                                <div className="text-14 text-muted">
                                    <span className='font-semibold'>Brand:</span> {brandName ? brandName : 'Unavailable'}
                                </div>
                                <div className="text-14 text-muted">
                                    <span className='font-semibold'>Group:</span> {groupName ? groupName : 'Unavailable'}
                                </div>
                            </React.Fragment>
                        )
                    }
                    {pathSegment === "campaigns" &&
                        <div className='flex items-center whitespace-nowrap'>
                            <input
                                type="checkbox"
                                id="includeTestDataCheckbox"
                                checked={includeTestData}
                                onChange={(e) => {
                                    setIncludeTestData(e.target.checked);
                                    setExportSelection(null);
                                }}
                                disabled={isCardDataLoading || isDomainDataLoading || isHeatmapDataLoading || isEmailDataLoading || exportLoading}
                                className="mr-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            />
                            <label
                                htmlFor="includeTestDataCheckbox"
                                className={`mr-1 font-medium text-14 ${isCardDataLoading || isDomainDataLoading || isHeatmapDataLoading || isEmailDataLoading || exportLoading
                                    ? 'text-[#9ca3af] cursor-not-allowed'
                                    : 'text-[#3a3a3a] cursor-pointer'
                                    }`}
                            >
                                Include Test Data
                            </label>
                        </div>
                    }

                </div>

                <div className='mb-[20px]'>
                    {
                        isCardDataLoading ? (
                            <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div>
                        ) :

                            <Grid
                                container
                                spacing={2}
                                sx={{
                                    mt: 1,
                                }}
                            >
                                {/* Audience */}
                                <Grid item xs={12} sm={6} md={4} lg={2.4}>
                                    <div className="box-container p-4 border rounded-lg shadow-sm bg-white h-full">
                                        <div className="flex items-center justify-center gap-x-2 mb-2">
                                            <div className="icon bg-[#EDEDFF] p-2 rounded-full">
                                                <HugeiconsIcon icon={UserIcon} size={20} color="#6B6BFB" strokeWidth={0.2} />
                                            </div>
                                            <div className="text-lg font-semibold text-title">Audience</div>
                                        </div>
                                        <div className="text-3xl font-bold text-center text-title">{cardData.totalNPI}</div>
                                        <div className="text-14 font-normal mb-2 text-subtitle text-center">Total Targets</div>
                                    </div>
                                </Grid>

                                {/* Delivery */}
                                <Grid item xs={12} sm={6} md={4} lg={2.4}>
                                    <div className="box-container p-4 border rounded-lg shadow-sm bg-white h-full">
                                        <div className="flex items-center justify-center gap-x-2 mb-2">
                                            <div className="icon bg-[#DBF7FB] p-2 rounded-full">
                                                <HugeiconsIcon icon={MailSend02Icon} size={20} color="#3FCEE1" strokeWidth={0.2} />
                                            </div>
                                            <div className="text-lg font-semibold text-title">Delivery</div>
                                        </div>
                                        <div className="text-3xl font-bold text-center text-title">{cardData.totalSends}</div>
                                        <div className="text-14 font-normal mb-2 text-subtitle text-center">Sent</div>
                                        <div className="flex justify-between text-sm gap-[5px] text-gray-600">
                                            <div className="text-subtitle count-container">
                                                <div className="text-14 font-semibold text-muted">
                                                    {cardData.totalSends}{" "}
                                                    {cardData.totalDelivered === 0
                                                        ? "(100%)"
                                                        : `(${Math.round((cardData.totalSends / cardData.totalDelivered) * 100)}%)`}
                                                </div>
                                                <div>Delivered</div>
                                            </div>
                                            <div className="text-subtitle count-container">
                                                <div className="text-14 font-semibold text-muted">
                                                    {cardData.totalBounces}{" "}
                                                    {cardData.totalSends === 0
                                                        ? "(100%)"
                                                        : `(${Math.round((cardData.totalBounces / cardData.totalSends) * 100)}%)`}
                                                </div>
                                                <div>Bounced</div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>

                                {/* Engagement */}
                                <Grid item xs={12} sm={6} md={4} lg={2.4}>
                                    <div className="box-container p-4 border rounded-lg shadow-sm bg-white h-full">
                                        <div className="flex items-center justify-center gap-x-2 mb-2">
                                            <div className="icon bg-[#DBF6D4] p-2 rounded-full">
                                                <HugeiconsIcon icon={MailOpen02Icon} size={24} color="#5FD242" strokeWidth={0.2} />
                                            </div>
                                            <div className="text-lg font-semibold text-title">Engagement</div>
                                        </div>
                                        <div className="text-3xl font-bold text-center text-title">{cardData.totalOpens}</div>
                                        <div className="text-14 font-normal mb-2 text-subtitle text-center">Opens</div>
                                        <div className="flex justify-between text-sm gap-[5px] text-gray-600">
                                            <div className="text-subtitle count-container">
                                                <div className="text-14 font-semibold text-muted">
                                                    {cardData.totalUniqueOpens}{" "}
                                                    {cardData.totalSends === 0
                                                        ? "(100%)"
                                                        : `(${Math.round((cardData.totalUniqueOpens / cardData.totalSends) * 100)}%)`}
                                                </div>
                                                <div>Unique Opens</div>
                                            </div>
                                            <div className="text-subtitle count-container">
                                                <div className="text-14 font-semibold text-muted">
                                                    {cardData.totalSends === 0
                                                        ? "100%"
                                                        : `${Math.round((cardData.totalOpens / cardData.totalSends) * 100)}%`}
                                                </div>
                                                <div>Open Rate</div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>

                                {/* Clicks */}
                                <Grid item xs={12} sm={6} md={4} lg={2.4}>
                                    <div className="box-container p-4 border rounded-lg shadow-sm bg-white h-full">
                                        <div className="flex items-center justify-center gap-x-2 mb-2">
                                            <div className="icon bg-[#E0ECFF] p-2 rounded-full">
                                                <HugeiconsIcon icon={Cursor02Icon} size={24} color="#4B8DF5" strokeWidth={0.2} />
                                            </div>
                                            <div className="text-lg font-semibold text-title">Clicks</div>
                                        </div>
                                        <div className="text-3xl font-bold text-center text-title">{cardData.totalClicks}</div>
                                        <div className="text-14 font-normal mb-2 text-subtitle text-center">Clicks</div>
                                        <div className="flex justify-between text-sm gap-[5px] text-gray-600">
                                            <div className="text-subtitle count-container">
                                                <div className="text-14 font-semibold text-muted">
                                                    {cardData.totalUniqueClicks}{" "}
                                                    {cardData.totalSumClicks === 0
                                                        ? "(100%)"
                                                        : `(${Math.round((cardData.totalUniqueClicks / cardData.totalSumClicks) * 100)}%)`}
                                                </div>
                                                <div>Unique Clicks</div>
                                            </div>
                                            <div className="text-subtitle count-container">
                                                <div className="text-14 font-semibold text-muted">
                                                    {cardData.totalClickToOpenRate}%
                                                </div>
                                                <div>CTO</div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>

                                {/* Feedback */}
                                <Grid item xs={12} sm={6} md={4} lg={2.4}>
                                    <div className="box-container p-4 border rounded-lg shadow-sm bg-white h-full">
                                        <div className="flex items-center justify-center gap-x-2 mb-2">
                                            <div className="icon bg-[#FEDADA] p-2 rounded-full">
                                                <HugeiconsIcon icon={MailBlock02Icon} size={24} color="#F95050" strokeWidth={0.2} />
                                            </div>
                                            <div className="text-lg font-semibold text-title">Feedback</div>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <div className="text-center">
                                                <div className="text-3xl font-bold text-title">{cardData.totalUnSubscribes}</div>
                                                <div className="text-14 font-normal mb-2 text-subtitle">Unsubscribes</div>
                                            </div>
                                            <div className="text-center">
                                                <div className="text-3xl font-bold text-title">{cardData.totalComplaints}</div>
                                                <div className="text-14 font-normal mb-2 text-subtitle">Complaints</div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>

                    }
                </div>

                <div className='mb-[20px]'>
                    <Grid container spacing={2} alignItems="stretch">
                        <Grid item xs={12} md={7} display="flex" flexDirection="column">
                            <div style={{
                                position: 'relative',
                                display: 'block',
                                height: '400px',
                                width: '100%',
                                overflow: 'hidden',
                                backgroundColor: '#fff',
                                boxSizing: 'border-box',
                                padding: '20px',
                                zIndex: 1,
                            }} className='graph-container reports-graph-container'>
                                <div className='flex justify-between items-center relative mb-[25px] right-[30px]'>
                                    <div className='text-[18px] font-semibold text-muted mb-5 ml-[29px]'>Sending Overview</div>
                                    <div>
                                        <ToggleButtonGroup size="medium" {...control} aria-label="Medium sizes">
                                            <ToggleButton value="line" aria-label="line">
                                                <HugeiconsIcon
                                                    icon={ChartLineData02Icon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                                />
                                            </ToggleButton>
                                            <ToggleButton value="bar" aria-label="bar">
                                                <HugeiconsIcon
                                                    icon={Chart01Icon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                                />
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                </div>
                                <React.Fragment>
                                    {
                                        isCardDataLoading ? <div className='flex justify-center items-center relative top-[40%]'><span className="loading loading-spinner text-primary"></span></div> :
                                            <React.Fragment>
                                                {
                                                    alignment === 'line' ? <LineChartComponent dataset={graphData} labels={inputLabels} interval={interval} /> : <BarGraphComponent dataset={graphData} labels={inputLabels} interval={interval} />
                                                }
                                            </React.Fragment>
                                    }

                                </React.Fragment>

                            </div>
                        </Grid>
                        <Grid item xs={12} md={5} display="flex" flexDirection="column">
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[400px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Email Domains</div>
                                <div className='click-url-table email-domain'>
                                    <CustomDataTable
                                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                        columns={domainColumns}
                                        data={domainCount}
                                        // pagination
                                        progressPending={isDomainDataLoading}
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>

                </div>

                <div >
                    <Grid container spacing={2}>
                        <Grid item xs={7}>
                            <div className='graph-container mb-[20px]'>
                                {/* <div className='text-[18px] font-semibold text-muted mb-5'>Send Time Heatmap</div> */}
                                <div className='flex justify-between items-center relative mb-[25px] right-[30px]'>
                                    <div className='text-[18px] font-semibold text-muted mb-5 ml-[29px]'>Send Time Heatmap</div>
                                    <div>
                                        <ToggleButtonGroup size="small" {...control1} aria-label="Medium sizes" sx={{ textTransform: 'capitalize' }}>
                                            <ToggleButton value="1" aria-label="delivered">
                                                Delivered
                                            </ToggleButton>
                                            <ToggleButton value="2" aria-label="opened">
                                                Opened
                                            </ToggleButton>
                                            <ToggleButton value="3" aria-label="clicked">
                                                Clicked
                                            </ToggleButton>
                                            <ToggleButton value="4" aria-label="unsubscribed">
                                                Unsubscribed
                                            </ToggleButton>
                                        </ToggleButtonGroup>

                                    </div>
                                </div>
                                {
                                    isHeatmapDataLoading ? <div className='flex justify-center items-center relative top-[40%]'><span className="loading loading-spinner text-primary"></span></div> :
                                        <div ref={containerRef} className="heatmap-container w-full overflow-x-auto">
                                            <HeatMap
                                                xLabels={xLabels}
                                                yLabels={yLabels}
                                                xLabelsLocation={"top"}
                                                xLabelsVisibility={xLabelsVisibility}
                                                xLabelWidth={70}
                                                data={heatmapData}
                                                height={45}
                                                // onClick={(x: any, y: any) => alert(`Clicked ${x}, ${y}`)}
                                                cellStyle={(background: any, value: any, min: any, max: any, data: any, x: any, y: any) => ({
                                                    background: `rgb(220, 5,  3, ${1 - (max - value) / (max - min)})`,
                                                    fontSize: "11.5px",
                                                    color: "#333",
                                                })}
                                                cellRender={(value: any) => value && <div>{value}</div>}
                                            />
                                        </div>
                                }

                            </div>
                        </Grid>
                        <Grid item xs={5}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[375px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Category Breakdown</div>
                                <div className='click-url-table device'>
                                    <CustomDataTable
                                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                        columns={categoryBreakdownColumns}
                                        data={categoryBreakdownCount}
                                        // pagination
                                        progressPending={isDomainDataLoading}
                                    />
                                </div>
                            </div>
                        </Grid>

                    </Grid>
                </div>


                <div className='mb-[20px]'>
                    <Grid container spacing={2}>
                        {/* Breakdown (previously Devices) */}
                        <Grid item xs={4}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[410px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Devices</div>
                                <div className='click-url-table device'>
                                    <CustomDataTable
                                        columns={deviceColumns}
                                        data={deviceCount}
                                        progressPending={isEmailDataLoading}
                                    />
                                </div>
                            </div>
                        </Grid>

                        {/* Clicks by URL */}
                        <Grid item xs={4}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[410px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Clicks by URL</div>
                                <div className='click-url-table'>
                                    <CustomDataTable
                                        columns={clickColumns}
                                        data={clickByURLCount}
                                        progressPending={isEmailDataLoading}
                                    />
                                </div>
                            </div>
                        </Grid>

                        {/* Top Email Clients */}
                        <Grid item xs={4}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[410px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Top Email Clients</div>
                                <div className='click-url-table'>
                                    <CustomDataTable
                                        columns={emailClientColumns}
                                        data={emailClientCount}
                                        progressPending={isEmailDataLoading}
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>

            </div>
        </>
    )
}

export default ViewCampaignReports